<template>
    <el-dialog
        :visible.sync="showObj.qrcode"
        :modal-append-to-body=false
        :show-close=false>
        <div class="modal-title">微信登录</div>
        <div class="qrcode" id="login_container">

        </div>

        <div class="btn-close" @click="showObj.qrcode = false"></div>
    </el-dialog>
</template>

<script>
    export default {
        props: ["showObj"],
        data() {
            return {

            };
        },
        created () {

        },
        updated () {
             this.show();
        },
        mounted () {

        },
        methods: {
            show () {
                var obj = new WxLogin({
                    id:"login_container",
                    appid: "wx7352ca7db7d0d2c8",
                    scope: "snsapi_login",
                    redirect_uri: "http://dev.api.evhui.com",
                    state: "",
                    style: "",
                    href: ""
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    $maincolor: #0666b2;
    .qrcode {
        display: block;
        width: 280px;
        height: 280px;
        margin: 40px auto 20px;
    }
    .tips {
        margin: 0 auto;
        text-align: center;
        font-size: 16px;
        color: #000;
    }
</style>



// WEBPACK FOOTER //
// Qrcode.vue?750d3421